import React from 'react';
import './OrbitOS.css';
import logoIcon from '../img/logo3.png';
import cdIcon from '../img/cd-icon.png';
import photoboothIcon from '../img/photobooth22.png';
import guestbookIcon from '../img/guestbook.png';
import gardenIcon from '../img/garden.png';
import orbitrunIcon from '../img/orbitrun.png';
import musicPlayerIcon from '../img/cd-icon.png';
import geniusIcon from '../img/genius.png';

interface OrbitOSProps {
  onOpenMusicPlayer: () => void;
  onOpenPhotoBooth: () => void;
  onOpenGuestbook: () => void;
  onOpenOrbitRun: () => void;
}

const MarqueeContent: React.FC = () => {
  return (
    <>
      <span className="marquee-item">
        <img src={photoboothIcon} alt="" className="marquee-icon" />
        SNAP A PHOTO IN PHOTOBOOTH
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">
        <img src={guestbookIcon} alt="" className="marquee-icon" />
        SIGN THE GUESTBOOK
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">
        <img src={gardenIcon} alt="" className="marquee-icon" />
        PLANT SEEDS IN YOUR GARDEN
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">
        <img src={orbitrunIcon} alt="" className="marquee-icon" />
        BEAT @VVS'S HIGH SCORE OF 1009
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">
        <img src={musicPlayerIcon} alt="" className="marquee-icon" />
        SAVE YOUR FAVORITE MUSIC
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">
        <img src={geniusIcon} alt="" className="marquee-icon" />
        ANNOTATE LYRICS, VOTE ON OTHERS
      </span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">ORBIT OS</span>
      <span className="marquee-separator"> / </span>
      <span className="marquee-item">THINK LESS, DO MORE</span>
      <span className="marquee-separator"> / </span>
    </>
  );
};

const OrbitOS: React.FC<OrbitOSProps> = ({
  onOpenMusicPlayer,
  onOpenPhotoBooth,
  onOpenGuestbook,
  onOpenOrbitRun
}) => {
  return (
    <div className="orbitos">
      <div className="marquee-container marquee-top">
        <div className="marquee-content marquee-left">
          <MarqueeContent />
          <MarqueeContent />
          <MarqueeContent />
        </div>
      </div>
      <div className="orbitos-content">
        <img src={logoIcon} alt="orbitOS logo" className="orbitos-logo" />

        <h1 className="orbitos-title">welcome to orbitOS</h1>

        <p className="orbitos-caption">
          tap to open an app:
        </p>

        <div className="orbitos-buttons">
          <button className="orbitos-button" onClick={onOpenMusicPlayer}>
            <img src={cdIcon} alt="CD" className="orbitos-button-icon" />
            <span>listen to the mixtape</span>
          </button>

          <button className="orbitos-button" onClick={onOpenPhotoBooth}>
            <img src={photoboothIcon} alt="Photo Booth" className="orbitos-button-icon" />
            <span>take some photos</span>
          </button>

          <button className="orbitos-button" onClick={onOpenGuestbook}>
            <img src={guestbookIcon} alt="Guestbook" className="orbitos-button-icon" />
            <span>sign the guestbook</span>
          </button>

          <button className="orbitos-button" onClick={onOpenOrbitRun}>
            <img src={orbitrunIcon} alt="OrbitRun" className="orbitos-button-icon" />
            <span>play orbit run</span>
          </button>
        </div>
      </div>
      <div className="marquee-container marquee-bottom">
        <div className="marquee-content marquee-right">
          <MarqueeContent />
          <MarqueeContent />
          <MarqueeContent />
        </div>
      </div>
    </div>
  );
};

export default OrbitOS;
